var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHappy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 172 172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,172v-172h172v172z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2ecc71"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86,17.2c-37.92928,0 -68.8,30.87072 -68.8,68.8c0,37.92928 30.87072,68.8 68.8,68.8c37.92928,0 68.8,-30.87072 68.8,-68.8c0,-37.92928 -30.87072,-68.8 -68.8,-68.8zM86,28.66667c31.73223,0 57.33333,25.6011 57.33333,57.33333c0,31.73223 -25.6011,57.33333 -57.33333,57.33333c-31.73223,0 -57.33333,-25.6011 -57.33333,-57.33333c0,-31.73223 25.6011,-57.33333 57.33333,-57.33333zM60.2,74.53333c-4.74965,0 -8.6,3.85035 -8.6,8.6c0,4.74965 3.85035,8.6 8.6,8.6c4.74965,0 8.6,-3.85035 8.6,-8.6c0,-4.74965 -3.85035,-8.6 -8.6,-8.6zM111.8,74.53333c-4.74965,0 -8.6,3.85035 -8.6,8.6c0,4.74965 3.85035,8.6 8.6,8.6c4.74965,0 8.6,-3.85035 8.6,-8.6c0,-4.74965 -3.85035,-8.6 -8.6,-8.6zM68.76641,108.88854c-2.43703,0.13676 -4.52035,1.80134 -5.19157,4.14811c-0.67123,2.34676 0.21679,4.86121 2.21292,6.26596c4.61136,3.35128 11.51668,6.83073 20.21224,6.83073c8.69556,0 15.60354,-3.47651 20.21224,-6.83073c1.65698,-1.20592 2.54456,-3.20438 2.32826,-5.24228c-0.21629,-2.03791 -1.50358,-3.80553 -3.37678,-4.63677c-1.8732,-0.83125 -4.0476,-0.59978 -5.70383,0.60718c-3.2689,2.37912 -7.82212,4.63594 -13.45989,4.63594c-5.63778,0 -10.19339,-2.25388 -13.47109,-4.63594c-0.92439,-0.69365 -2.03681,-1.09178 -3.19141,-1.14218c-0.19025,-0.00949 -0.38085,-0.00949 -0.57109,0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappy);
export default __webpack_public_path__ + "static/media/happy.193575b8e12ff6b21fb5286e93879834.svg";
export { ForwardRef as ReactComponent };